import React from "react";
import TableImage from "../../shared/TableCard/TableImage";
import TableCard from "../../shared/TableCard/TableCard";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode, FilterOperator } from "primereact/api";

export default function OurClientTable({ heading, allOurClients, loading, history, search, setSearch, onDelete, selection = false }) {
    const actions = (d) => {
        return (
            <div className="flex justify-content-around gap-1">
                <i className="pi pi-eye cursor-pointer" onClick={() => history.push(`our-clients/view/${d._id}`)}></i>
                <i className="pi pi-pencil cursor-pointer" onClick={() => history.push(`our-clients/edit/${d._id}`)}></i>
                <i className="pi pi-trash cursor-pointer" onClick={(e) => onDelete(e, d._id)}></i>
            </div>
        );
    };

    const image = (r) => {
        const image = r?.author?.image;
        return <TableImage image={image} />;
    };

    const filters = {
        time: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        subscriptionExpireOn: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    };

    return (
        <>
            <TableCard title={heading} onSearch={setSearch} searchKeyword={search} buttonTitle="Add Client" linkTo={`/our-clients/add`}>
                <DataTable
                    paginator
                    value={allOurClients}
                    selectionMode="checkbox"
                    showGridlines
                    filter={filters}
                    filterDisplay="menu"
                    rows={10}
                    loading={loading}
                    emptyMessage="No user found."
                >
                    {selection ? <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column> : null}
                    <Column field="title" header="Title" style={{ width: "250px" }}></Column>
                    <Column field="description" header="Description" style={{ width: "600px" }}></Column>
                    <Column field="author.name" header="Author Name" style={{ width: "250px" }}></Column>
                    <Column body={image} header="Image" style={{ width: "80px" }}></Column>
                    <Column field="author.role" header="Role" style={{ width: "250px" }}></Column>
                    <Column body={actions} style={{ width: "100px" }} header="Action"></Column>
                </DataTable>
            </TableCard>
        </>
    );
}
